<template>
  <BaseInnerSidebar :show-title="false">
    <template #title>
      <div class="flex items-center gap-2">
        <i class="pi pi-cog text-primary-600" />
        <span>Workspace Settings</span>
      </div>
    </template>
    <template #content>
      <nav class="space-y-1">
        <nuxt-link
          v-for="(tab, index) in visibleTabs"
          :key="index"
          :to="tab.route"
          class="block"
        >
          <BaseSidebarOption :is-active="tab.active">
            <Icon
              :name="tab.icon"
              class="text-base w-4"
            />
            <span>{{ tab.name }}</span>
          </BaseSidebarOption>
        </nuxt-link>
      </nav>
    </template>
  </BaseInnerSidebar>
</template>

<script lang="ts" setup>
import { SettingIcon } from '~/types/baseIcon'
import { Capabilities } from '~/composables/useRolePermissions'

const route = useRoute()
const { can } = useRolePermissions()

const routeName = computed(() => route.name as string)

const tabs = computed(() => [
  {
    name: 'Brand',
    icon: SettingIcon.BRAND,
    route: { name: 'settings-brand' },
    active: routeName.value === 'settings-brand',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Business',
    icon: SettingIcon.BUSINESS,
    route: { name: 'settings-business' },
    active: routeName.value === 'settings-business',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Features',
    icon: SettingIcon.FEATURES,
    route: { name: 'settings-features' },
    active: routeName.value === 'settings-features',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Listings Widget',
    icon: SettingIcon.LISTINGS,
    route: { name: 'settings-listings' },
    active: routeName.value === 'settings-listings',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Integration',
    icon: SettingIcon.INTEGRATION,
    route: { name: 'settings-integration' },
    active: routeName.value === 'settings-integration',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Authentication',
    icon: SettingIcon.AUTHENTICATION,
    route: { name: 'settings-authentication' },
    active: routeName.value === 'settings-authentication',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  {
    name: 'Email Compliance',
    icon: SettingIcon.EMAIL_COMPLIANCE,
    route: { name: 'settings-email-compliance' },
    active: routeName.value === 'settings-email-compliance',
    capability: Capabilities.SETTINGS.WORKSPACE,
  },
  // {
  //   name: 'Billing',
  //   icon: SettingIcon.BILLING,
  //   route: { name: 'settings-billing' },
  //   active: routeName.value === 'settings-billing',
  //   capability: Capabilities.SETTINGS.BILLING,
  // },
])

const visibleTabs = computed(() => tabs.value.filter(tab => can(tab.capability)))
</script>
